const navigator = window.navigator;
export const isDTRuntime = navigator && /DingTalk/.test(navigator.userAgent);

// TODO wx_work while coming soon
export const withinThirdPartyIntegration = isDTRuntime;
